import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import BackLink from 'components/BackLink';
import useMatchMedia from 'hooks/useMatchMedia';
import XIcon from 'icons/X.icon';

import './AgreementPageLayout.styles.scss';
import './AgreementPageLayout.styles.responsive.scss';

type AgreementPageLayoutProps = {
  className?: string;
  title: string;
  subtitle?: ReactNode;
  backPath?: string;
  backLabel?: string;
  actions?: ReactNode;
  footer?: ReactNode;
  onClose?: () => void;
};

const AgreementPageLayout: React.FC<AgreementPageLayoutProps> = (props) => {
  const {
    className,
    title,
    subtitle,
    backPath,
    backLabel,
    actions,
    footer,
    onClose,
    children,
  } = props;

  const isPhablet = useMatchMedia('isPhablet');

  const { t } = useTranslation();

  const classes = classNames('agreement-page-layout', className);

  return (
    <div className={classes}>
      <header className="agreement-page-layout__header">
        {backPath && (
          <BackLink
            to={backPath}
            title={backLabel}
            aria-label={backLabel || t('back')}
          >
            {!isPhablet && backLabel && <span>{backLabel}</span>}
          </BackLink>
        )}

        {onClose && (
          <Button
            type="button"
            variant="icon"
            icon={XIcon}
            aria-label={t('close')}
            onClick={onClose}
          />
        )}

        <div className="agreement-page-layout__title">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>

        {actions && (
          <div className="agreement-page-layout__actions">{actions}</div>
        )}
      </header>

      <main className="agreement-page-layout__content">{children}</main>

      {footer}
    </div>
  );
};

export default AgreementPageLayout;
